import { useFragment } from "react-relay"
import { getEpisodeOfCareFragment } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-fragment"
import { EpisodeOfCareFragment$key } from "@/modules/patients/detail/episode-of-care/types/episode-of-care-fragment-type"
import { useEpisodeOfCareStoreContext } from "@/modules/patients/detail/store/useEpisodeOfCareStore"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"

const useEpisodeOfCareByProgressNoteId = (progressNoteId: string) => {
  const countryCode = useCountryParam()
  const progressNoteAndParentData = useEpisodeOfCareStoreContext((state) => state.progressNoteAndParentData)
  const progressNote = progressNoteAndParentData.find(
    (progressNode) => progressNode.episodeOfCareProgressNoteData.id === progressNoteId,
  )

  if (!progressNote) {
    throw new Error("Progress note not found")
  }

  const episodeOfCare = useFragment<EpisodeOfCareFragment$key>(
    getEpisodeOfCareFragment(countryCode),
    progressNote.parentEpisodeOfCare,
  )

  const icdCode = episodeOfCare.icdDiagnosis.diagnosisCode
  const isBetterDocUsed = progressNote.episodeOfCareProgressNoteData.betterDoc?.isUsed

  return { icdCode, isBetterDocUsed }
}

export { useEpisodeOfCareByProgressNoteId }
